'use strict';

var React = require('react');
var technicalError = require('@andes/technical-error');
var BaseWithIllustration = require('@andes/technical-error/build/presets/BaseWithIllustration');
var melidataTrack_js = require('frontend-melidata/melidata-track.js');
var context = require('@andes/context');
var _regeneratorRuntime = require('@babel/runtime/helpers/regeneratorRuntime');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _extends = require('@babel/runtime/helpers/extends');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var snackbar = require('@andes/snackbar');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');

/* eslint-disable no-console */
var trackWebRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(errorUXContext, visualType) {
    var _errorUXContext$userI;
    var env, baseUrl, body, requestOptions;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          env = errorUXContext.env === 'production' && !errorUXContext.isTest ? '' : 'stage/';
          baseUrl = "https://api.mercadolibre.com/".concat(env, "errorux/traces");
          body = [{
            x_request_id: errorUXContext.requestId || 'dev',
            user_id: ((_errorUXContext$userI = errorUXContext.userId) === null || _errorUXContext$userI === void 0 ? void 0 : _errorUXContext$userI.toString()) || '',
            application: errorUXContext.application,
            app_version: errorUXContext.appVersion,
            site: errorUXContext.site || '',
            error_id: errorUXContext.uniqueErrorCode,
            team: errorUXContext.team || 'BAB',
            number: errorUXContext.number || '01',
            custom_data: errorUXContext.customData,
            detail: errorUXContext.detail,
            screen: errorUXContext.path || '',
            app_data: {
              fury_application_id: errorUXContext.appName
            },
            device_data: {
              browser: errorUXContext.deviceData.name || 'undefined',
              browser_version: errorUXContext.deviceData.version || 'undefined',
              os: errorUXContext.deviceData.osName || 'undefined',
              os_version: errorUXContext.deviceData.osVersion || 'undefined',
              user_agent: errorUXContext.deviceData.userAgent || 'undefined',
              platform: '/web/'.concat(errorUXContext.deviceData.type)
            },
            visual_type: visualType,
            status_code: errorUXContext.statusCode
          }];
          requestOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            mode: 'cors'
          };
          return _context2.abrupt("return", fetch(baseUrl, requestOptions).then(/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (response.ok) {
                      _context.next = 2;
                      break;
                    }
                    throw new Error('Error sending trace request');
                  case 2:
                    return _context.abrupt("return", response.json());
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x3) {
              return _ref2.apply(this, arguments);
            };
          }()).then(function (data) {
            return data;
          })["catch"](function (error) {
            console.error('There was a problem with the fetch post trace:', error);
          }));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function trackWebRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* eslint-disable no-console */
var trackErrorUX = function trackErrorUX(errorUXContext, visualType) {
  console.debug('received web error context and sending it to ...');
  trackWebRequest(errorUXContext, visualType).then(function (data) {
    console.debug('Track request response:', data);
  })["catch"](function (error) {
    console.error('Error:', error);
  });
  return errorUXContext;
};

/* global melidata:readonly */
/* eslint-disable no-console */
var trackPath = '/error/generic';
var melidataScriptURL = 'https://http2.mlstatic.com/storage/melidata-js-sdk/js/3/last/melidata.min.js';
var scriptName = 'melidata-script';
var loadMelidata = function loadMelidata(callback) {
  if (typeof melidata === 'undefined') {
    var script = document.createElement('script');

    // script.id = scriptName;
    script.setAttribute('id', scriptName);
    script.setAttribute('src', melidataScriptURL);
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('async', true);
    document.body.appendChild(script);
    script.addEventListener('load', function () {
      callback();
    });
  } else {
    callback();
  }
};
var trackToMelidata = function trackToMelidata(context, visualType) {
  loadMelidata(function () {
    melidata('cleanAndSend', 'view', {
      path: trackPath,
      data: {
        team: context.team,
        id: context.uniqueErrorCode,
        visual_type: visualType,
        number: context.number,
        screen: context.path,
        fury_application_id: context.appName,
        error_code: String(context.statusCode)
      }
    });
    // removeMelidata();
  });
};
var module$3 = "error-ux-components";
var locale$2 = "en-US";
var translations$2 = {
  "error-ux-components\u0004REINTENTAR": [null, "RETRY"],
  "error-ux-components\u0004Reintentar": [null, "Retry"],
  "error-ux-components\u0004Cerrar": [null, "Close"],
  "error-ux-components\u0004Ocurrió un error temporal": [null, "A temporary error occurred"],
  "error-ux-components\u0004Estamos experimentando un error temporal": [null, "We are experiencing a temporary error"],
  "error-ux-components\u0004Estamos trabajando para solventarlo": [null, "We are working to solve it"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "error-ux-components";
var locale$1 = "es-AR";
var translations$1 = {
  "error-ux-components\u0004REINTENTAR": [null, "REINTENTAR"],
  "error-ux-components\u0004Reintentar": [null, "Reintentar"],
  "error-ux-components\u0004Cerrar": [null, "Cerrar"],
  "error-ux-components\u0004Ocurrió un error temporal": [null, "Ocurrió un error temporal"],
  "error-ux-components\u0004Estamos experimentando un error temporal": [null, "Estamos experimentando un error temporal"],
  "error-ux-components\u0004Estamos trabajando para solventarlo": [null, "Estamos trabajando para solventarlo"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "error-ux-components";
var locale = "pt-BR";
var translations = {
  "error-ux-components\u0004REINTENTAR": [null, "TENTAR NOVAMENTE"],
  "error-ux-components\u0004Reintentar": [null, "Tentar novamente"],
  "error-ux-components\u0004Cerrar": [null, "Fechar"],
  "error-ux-components\u0004Ocurrió un error temporal": [null, "Ocorreu um erro temporário"],
  "error-ux-components\u0004Estamos experimentando un error temporal": [null, "Estamos enfrentando um erro temporário"],
  "error-ux-components\u0004Estamos trabajando para solventarlo": [null, "Estamos trabalhando para resolver"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};

/* global MobileWebKit:readonly */

/**
 * @typedef {object} ErrorContext
 * @property {{ nativeApp: boolean }} [deviceData]
 * @property {string} team
 * @property {string} number
 * @property {string} [detail]
 * @property {string} [appName]
 * @property {string} [appVersion]
 * @property {string} [path]
 * @property {number} [statusCode]
 * @property {object} [customData]
 * @property {string} [requestId]
 * @property {string} uniqueErrorCode
 *
 * @typedef {object} ErrorUXScreenProps
 * @property {string} [title]
 * @property {string} [description]
 * @property {ErrorContext} errorContext
 * @property {boolean} [isRetryEnabled]
 * @property {Function} [retry]
 */

var visualType$1 = 'full_screen';
var namespace$1 = 'error-ux-components';

/** @type {React.FunctionComponent<ErrorUXScreenProps>} */
var ErrorUXScreen = function ErrorUXScreen(_ref) {
  var _errorContext$deviceD2;
  var title = _ref.title,
    description = _ref.description,
    errorContext = _ref.errorContext,
    _ref$isRetryEnabled = _ref.isRetryEnabled,
    isRetryEnabled = _ref$isRetryEnabled === void 0 ? false : _ref$isRetryEnabled,
    _ref$retry = _ref.retry,
    retry = _ref$retry === void 0 ? null : _ref$retry;
  var i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
  React.useEffect(function () {
    var _errorContext$deviceD;
    if (errorContext !== null && errorContext !== void 0 && (_errorContext$deviceD = errorContext.deviceData) !== null && _errorContext$deviceD !== void 0 && _errorContext$deviceD.nativeApp && 'MobileWebKit' in window) {
      MobileWebKit.errors.showErrorScreen({
        errorContext: {
          team: errorContext.team,
          number: errorContext.number,
          detail: errorContext.detail,
          appName: errorContext.appName,
          appVersion: errorContext.appVersion,
          path: errorContext.path || window.location.href,
          statusCode: errorContext.statusCode,
          customData: errorContext.customData,
          requestId: errorContext.requestId,
          // eslint-disable-next-line no-warning-comments
          owner: errorContext.team,
          // TODO remove when mobile-webkit gets updated
          // eslint-disable-next-line no-warning-comments
          code: errorContext.number // TODO remove when mobile-webkit gets updated
        },
        screenConfig: {
          title: title,
          subtitle: description,
          isRetryEnabled: isRetryEnabled,
          retry: retry
        }
      });
    } else if (errorContext.statusCode !== 429) {
      trackErrorUX(errorContext, visualType$1);
    }
  }, [title, description, errorContext, isRetryEnabled, retry]);
  function chooseComponent(customTitle, customDesc, props) {
    if ((errorContext === null || errorContext === void 0 ? void 0 : errorContext.statusCode) === 429) {
      return /*#__PURE__*/React.createElement(technicalError.ErrorScreen, {
        title: i18n.pgettext(namespace$1, 'Estamos experimentando un error temporal'),
        description: i18n.pgettext(namespace$1, 'Estamos trabajando para solventarlo'),
        errorCode: undefined,
        locale: errorContext.locale,
        device: errorContext.deviceData
      });
    }
    if ((customTitle === null || customTitle === void 0 ? void 0 : customTitle.trim().length) > 0 && (customDesc === null || customDesc === void 0 ? void 0 : customDesc.trim().length) > 0) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(technicalError.ErrorScreen, props), /*#__PURE__*/React.createElement(melidataTrack_js.MelidataTrack, {
        path: trackPath,
        event_data: {
          team: errorContext.team,
          id: errorContext.uniqueErrorCode,
          visual_type: visualType$1,
          number: errorContext.number,
          screen: errorContext.path,
          fury_application_id: errorContext.appName,
          error_code: String(errorContext.statusCode)
        }
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BaseWithIllustration, props), /*#__PURE__*/React.createElement(melidataTrack_js.MelidataTrack, {
      path: trackPath,
      event_data: {
        team: errorContext.team,
        id: errorContext.uniqueErrorCode,
        visual_type: visualType$1,
        number: errorContext.number,
        screen: errorContext.path,
        fury_application_id: errorContext.appName,
        error_code: String(errorContext.statusCode)
      }
    }));
  }
  var errorCode = "".concat(errorContext.team).concat(errorContext.number, "-").concat(errorContext.uniqueErrorCode);
  var retryAction = isRetryEnabled && retry ? {
    text: i18n.pgettext(namespace$1, 'Reintentar'),
    onClick: retry
  } : null;
  return !(errorContext !== null && errorContext !== void 0 && (_errorContext$deviceD2 = errorContext.deviceData) !== null && _errorContext$deviceD2 !== void 0 && _errorContext$deviceD2.nativeApp) && chooseComponent(title, description, {
    title: title,
    description: description,
    errorCode: errorCode,
    action: retryAction,
    locale: errorContext.locale,
    device: errorContext.deviceData
  });
};
var defaultSnackbarAction = function defaultSnackbarAction() {};

/**
 * <b>SnackbarDuration</b> </br>
 *
 * <b>SHORT</b>: Message will be displayed for 3000 milliseconds </br>
 * <b>NORMAL</b>: Message will be displayed for 6000 milliseconds </br>
 * <b>LONG</b>: Message will be displayed for 10000 milliseconds </br>
 * <b>INFINITE</b>: Message will be displayed for infinite time </br>
 *
 * @returns {number} SnackbarDuration value in milliseconds.
 */
var SnackbarDuration = Object.freeze({
  SHORT: Number(3000),
  NORMAL: Number(6000),
  LONG: Number(10000),
  INFINITE: Number(0)
});

/**
 * @typedef {object} ErrorUXSnackbarProps
 * @property {string} message
 * @property {boolean} [show]
 * @property {import('../Screen').ErrorContext} errorContext
 * @property {boolean} [isRetryEnabled]
 * @property {Function} [retry]
 */

var visualType = 'snackbar';
var namespace = 'error-ux-components';

/** @type {React.FunctionComponent<ErrorUXSnackbarProps>} */
var ErrorUXSnackbar = function ErrorUXSnackbar(props) {
  var _errorContext$deviceD4;
  var message = props.message,
    show = props.show,
    errorContext = props.errorContext,
    isRetryEnabled = props.isRetryEnabled,
    retry = props.retry,
    delay = props.delay;
  var i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
  var _useState = React.useState(show),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  React.useEffect(function () {
    setIsShown(show);
  }, [show, message, errorContext]);
  var delayToUse = delay !== null && delay !== void 0 ? delay : SnackbarDuration.NORMAL;
  React.useEffect(function () {
    var _errorContext$deviceD;
    if (errorContext !== null && errorContext !== void 0 && (_errorContext$deviceD = errorContext.deviceData) !== null && _errorContext$deviceD !== void 0 && _errorContext$deviceD.nativeApp && 'MobileWebKit' in window && show) {
      var closedTxt = i18n.pgettext(namespace, 'Cerrar');
      MobileWebKit.errors.showErrorSnackbar({
        errorContext: {
          team: errorContext.team,
          number: errorContext.number,
          detail: errorContext.detail,
          appName: errorContext.appName,
          appVersion: errorContext.appVersion,
          path: errorContext.path || window.location.href,
          customData: errorContext.customData,
          statusCode: errorContext.statusCode,
          requestId: errorContext.requestId,
          // eslint-disable-next-line no-warning-comments
          owner: errorContext.team,
          // TODO remove when mobile-webkit gets updated
          // eslint-disable-next-line no-warning-comments
          code: errorContext.number // TODO remove when mobile-webkit gets updated
        },
        snackbarConfig: {
          message: message,
          actionLabel: isRetryEnabled ? i18n.pgettext(namespace, 'REINTENTAR') : closedTxt,
          isRetryEnabled: isRetryEnabled,
          retry: isRetryEnabled && retry ? retry : defaultSnackbarAction,
          duration: delayToUse
        }
      });
    } else if (errorContext.statusCode !== 429) {
      trackToMelidata(errorContext, visualType);
      trackErrorUX(errorContext, visualType);
    }
  }, [errorContext, i18n, isRetryEnabled, message, retry, delayToUse, show]);
  var retryAction = isRetryEnabled && retry ? {
    text: i18n.pgettext(namespace, 'REINTENTAR'),
    onClick: function onClick() {
      setIsShown(false);
      retry();
    },
    position: 'right'
  } : null;

  // eslint-disable-next-line @typescript-eslint/no-shadow
  function chooseComponent(props) {
    var _errorContext$deviceD3;
    if (errorContext.statusCode === 429) {
      var _errorContext$deviceD2;
      return !(errorContext !== null && errorContext !== void 0 && (_errorContext$deviceD2 = errorContext.deviceData) !== null && _errorContext$deviceD2 !== void 0 && _errorContext$deviceD2.nativeApp) && /*#__PURE__*/React.createElement(snackbar.Snackbar, {
        show: show,
        message: i18n.pgettext(namespace, 'Ocurrió un error temporal'),
        color: "red",
        delay: true
      });
    }
    return !(errorContext !== null && errorContext !== void 0 && (_errorContext$deviceD3 = errorContext.deviceData) !== null && _errorContext$deviceD3 !== void 0 && _errorContext$deviceD3.nativeApp) && /*#__PURE__*/React.createElement(technicalError.SnackbarWithErrorCode, _extends({}, props, {
      show: isShown,
      delay: delayToUse
    }));
  }
  return !(errorContext !== null && errorContext !== void 0 && (_errorContext$deviceD4 = errorContext.deviceData) !== null && _errorContext$deviceD4 !== void 0 && _errorContext$deviceD4.nativeApp) && chooseComponent({
    show: show,
    message: message,
    delay: delay,
    errorCode: "".concat(errorContext.team).concat(errorContext.number, "-").concat(errorContext.uniqueErrorCode),
    action: retryAction
  });
};

/* eslint-disable @typescript-eslint/no-unused-vars */
var ERROR_CODE_BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var ERROR_CODE_ID_SIZE = 12;
var uniqueErrorCode = function uniqueErrorCode() {
  return ERROR_CODE_BASE_CHARS.split('').map(function (s) {
    return ERROR_CODE_BASE_CHARS.charAt(Math.floor(Math.random() * ERROR_CODE_BASE_CHARS.length));
  }).join('').substring(0, ERROR_CODE_ID_SIZE).toUpperCase();
};
var getApplication = function getApplication() {
  return process.env.APPLICATION || 'dev';
};
var getVersion = function getVersion() {
  return process.env.VERSION || 'dev';
};
var getEnvironment = function getEnvironment() {
  return process.env.NODE_ENV || 'dev';
};
var isTestEnvironment = function isTestEnvironment() {
  return (process.env.FURY_IS_TEST_SCOPE || '').toLowerCase() === 'true';
};
var getBusinessUnit = new Map([['ML', 'mercadolibre'], ['MP', 'mercadopago'], ['MS', 'mercadoshops'], ['MT', 'metroscubicos'], ['GI', 'guiadinmuebles'], ['PI', 'portalinmobiliario'], ['TI', 'tuinmueble'], ['TC', 'tucarro'], ['TM', 'tumoto'], ['TL', 'tulancha'], ['AP', 'autoplaza'], ['BC', 'becommerce'], ['BO', 'adminml']]);
var getErrorUXContext = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _getBusinessUnit$get, _req$i18n, _req$auth;
    var team, number, req, res, detail, customData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          team = _ref.team, number = _ref.number, req = _ref.req, res = _ref.res, detail = _ref.detail, customData = _ref.customData;
          if (req.device.nativeApp) {
            res.setHeader('x-errorux', 'true');
          }
          return _context.abrupt("return", Promise.resolve({
            appName: getApplication(),
            appVersion: getVersion(),
            deviceData: _objectSpread(_objectSpread({}, req.device), req.browser),
            application: (_getBusinessUnit$get = getBusinessUnit.get(req.platform.id)) !== null && _getBusinessUnit$get !== void 0 ? _getBusinessUnit$get : 'no-match',
            url: "https://".concat(req.get('host')).concat(req.originalUrl),
            path: req.originalUrl,
            site: req.platform.siteId,
            locale: (_req$i18n = req.i18n) === null || _req$i18n === void 0 ? void 0 : _req$i18n.locale,
            userId: (_req$auth = req.auth) === null || _req$auth === void 0 ? void 0 : _req$auth.user.id,
            requestId: req.get('x-request-id'),
            team: team,
            number: number,
            statusCode: res.statusCode,
            detail: detail,
            customData: customData,
            uniqueErrorCode: uniqueErrorCode(),
            env: getEnvironment(),
            isTest: isTestEnvironment()
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getErrorUXContext(_x) {
    return _ref2.apply(this, arguments);
  };
}();
exports.ErrorUXScreen = ErrorUXScreen;
exports.ErrorUXSnackbar = ErrorUXSnackbar;
exports.SnackbarDuration = SnackbarDuration;
exports.getErrorUXContext = getErrorUXContext;
